import React from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ModuleType } from '../../../../../types/modules';
import Zone, { ZoneGroup } from '../../../Layout/Zone';
import { ZoneType } from '../../../../../types/layout';
import withSectionFetchSpinner from '../../../../decorators/withSectionFetchSpinner';

import CommissionSlider from './CommissionSlider';
import PrintsSlider from './PrintsSlider';
import PremiumContentSlider from './PremiumContentSlider';
import PremiumFolderSlider from './PremiumFolderSlider';
import DasSlider from './DasSlider';
import EmptyState from '../_partials/EmptyState';

const mapModuleTypeToWidgetComponent = {
  [ModuleType.PREMIUM_FOLDERS]: PremiumFolderSlider,
  [ModuleType.COMMISSIONS]: CommissionSlider,
  [ModuleType.PRINTS]: PrintsSlider,
  [ModuleType.PREMIUM_CONTENT]: PremiumContentSlider,
  [ModuleType.DAS]: DasSlider,
};

export interface Props {
  className?: string;
  isEmpty?: boolean;
  isCurrentUserProfileOwner?: boolean;
}

const defaultProps = {};

const enhance = compose(withSectionFetchSpinner, withTranslation());
export class ShopAll extends React.Component<Props & WithTranslation> {
  static defaultProps: Props = defaultProps;
  render() {
    const { isEmpty, isCurrentUserProfileOwner } = this.props;
    if (isEmpty && !isCurrentUserProfileOwner) {
      return <EmptyState view="large" />;
    }

    return (
      <div className={this.props.className}>
        <ZoneGroup>
          <Zone
            type={ZoneType.TOP_BAR}
            isRemovable={false}
            mapModuleTypeToWidgetComponent={mapModuleTypeToWidgetComponent}
          />
        </ZoneGroup>
      </div>
    );
  }
}

export default enhance(ShopAll) as React.ComponentType<Props>;
